import { makeStyles } from "@material-ui/styles"
import { useTranslation } from "react-i18next";

interface IProps {
    venueId: number;
}

const useStyles = makeStyles({
    root: {
        borderRadius: "20px",
        background: "#F3F4F9",
        color: "#737FA4",
        width: "9.5rem",
        padding: "0.2rem 0.5rem",
        fontSize: "0.95rem"
    },
    right: {
        float: "right"
    },
    left: {
        float: "left"
    }
})

export function VenueIdWrapper({ venueId }: IProps) {
    const { root, right, left } = useStyles();
    const { t } = useTranslation();
    return <div className={root}>
        <span className={left}>{t('OverviewPage.OverviewSearch.idWrapper')}</span>
        <span className={right}>{venueId}</span>
    </div>
}


